import { reduceValidationResults } from '../validators';
import { t } from '../../../utils/translate';

export const ratingRequired = state => {
  const isValid = !!state.value.toString().length;
  const errorMessages = isValid ? null : [t('must_choose_one')];
  return reduceValidationResults(state, {
    errorMessages,
    isValid,
  });
};

export const matrixRatingRequired = state => {
  const rowValids = state.rows.map(row => !!row.value.toString().length);
  const isValid = rowValids.every(v => v === true);
  const errorMessages = isValid ? null : [t('must_make_one_entry_per_row')];
  return reduceValidationResults(state, {
    errorMessages,
    isValid,
    rowValids,
  });
};
